// extracted by mini-css-extract-plugin
module.exports = {"disconnected":"DisconnectionComment__disconnected--Ui"};